<template>
    <div class="modalBackground">
        <div class="ModalForm">
            <div class="header">
                <h1 class="Title">User Note's</h1>
                <div class="Options">
                    <button v-on:click.stop="$emit('user-notes-cancelled')" >Close</button>
                </div>
            </div>
            <div class="modalBody">
                <table>
                    <thead>
                        <tr>
                            <th>Note</th>
                            <th>Author</th>
                            <th>Date Added</th>
                        </tr>
                    </thead>
                    <tbody v-if="UserNotes !== null">
                        <tr v-for="(userNote,index) in UserNotes" :key="index">
                            <td>{{ userNote.text }} </td>
                            <td>{{ userNote.author }}</td>
                            <td>{{ userNote.notesDate }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: 'UserNotes',
        props: ["UserNotes"],
        components: {
        },
        watch: {

        },
        data: function () {
            return {

            }
        },
        created: function () {

        },
        methods: {
            
        },
        computed: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->